// Single source of truth for the enemy portrait spritesheet.
//
// This mapping used to be copy-pasted into six components, and only one copy
// was updated when the werewolf enemy was renamed to "gnoll" - every other
// surface (new-enemy badge/card, codex, enemy portrait) silently rendered
// nothing for gnolls. Keep additions here and only here.
export const ENEMY_SPRITESHEET = "/images/enemies/enemies-sprites.png"

// Number of 64px cells in the strip
export const ENEMY_SPRITE_COUNT = 16

// Sprite cell per enemy type id (16 cells of 64px, left to right)
export const ENEMY_SPRITE_INDEX: Record<string, number> = {
  rat: 0,
  goblin: 1,
  mushroom: 2,
  lizardman: 3,
  zombie: 4,
  skeleton: 5,
  orc: 6,
  ghost: 7,
  gnoll: 8,
  werewolf: 8, // legacy id for the same sprite (soldiers turned by lycanthropy)
  golem: 9,
  lich: 10,
  vampire: 11,
  imp: 12,
  ent: 13,
  beholder: 14,
  demon: 15,
}
